// import React from 'react';
// import styles from '../../assets/scss/Dashboard.module.scss';
// import {
//     FiBox,
//     FiUsers,
//     FiClock,
// } from 'react-icons/fi';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { useNavigate } from 'react-router-dom';
// import dummyProfile from "../../assets/images/Profile.png";
// import { useGetDashboardQuery } from '../../slices/admin/admin';
// import { BaseURL } from '../../lib/api';

// const EmployeeDashboard = () => {
//     const navigate = useNavigate();

//     const { data, isLoading, isError } = useGetDashboardQuery();

//     // ✅ Handle loading and error states
//     if (isLoading) {
//         return <div className={styles.loader}>Loading dashboard...</div>;
//     }

//     if (isError) {
//         return <div className={styles.error}>Failed to load dashboard data.</div>;
//     }

//     // ✅ Extract data safely
//     const dashboard = data?.data || {};

//     const {
//         totalAssignedInvoices = 0,
//         invoiceNeedAttention = 0,
//         totalOrderAssigned = 0,
//         orderNeedAttention = 0,
//         notifications = [],
//         // bannerImages = [],
//     } = dashboard;

//     return (
//         <div className={styles.dashboard}>
//             {/* ✅ Top Overview Section */}
//             <div className={styles.grid}>
//                 {/* ✅ Invoice Overview */}
//                 <div className={styles.card}>
//                     <div className={styles.header}>
//                         <h4 className={styles.heading}>Invoice Overview</h4>
//                         <span onClick={() => navigate("/dashboard/Invoicetable")}>View all</span>
//                     </div>
//                     <div className={styles.overviewGridsEmployee}>
//                         <div className={`${styles.box} ${styles.orange}`}>
//                             <FiBox className={styles.icon} />
//                             <h3>{totalAssignedInvoices}</h3>
//                             <p>Total Assigned Invoices</p>
//                         </div>
//                         <div className={`${styles.box} ${styles.purple}`}>
//                             <FiUsers className={styles.icon} />
//                             <h3>{invoiceNeedAttention}</h3>
//                             <p>Invoices Needing Attention</p>
//                         </div>
//                     </div>
//                 </div>

//                 {/* ✅ Order Overview */}
//                 <div className={styles.card}>
//                     <div className={styles.header}>
//                         <h4 className={styles.heading}>Order Overview</h4>
//                         <span onClick={() => navigate("/dashboard/Ordertable")}>View all</span>
//                     </div>
//                     <div className={styles.overviewGridsEmployee}>
//                         <div className={`${styles.box} ${styles.green}`}>
//                             <FiBox className={styles.icon} />
//                             <h3>{totalOrderAssigned}</h3>
//                             <p>Total Orders Assigned</p>
//                         </div>
//                         <div className={`${styles.box} ${styles.pink}`}>
//                             <FiUsers className={styles.icon} />
//                             <h3>{orderNeedAttention}</h3>
//                             <p>Orders Needing Attention</p>
//                         </div>
//                     </div>
//                 </div>

//                 {/* ✅ Notifications Section */}
//                 <div className={styles.card}>
//                     <div className={styles.header}>
//                         <h4 className={styles.heading}>Notifications</h4>
//                         <span onClick={() => navigate('/dashboard/Notifications')}>View all</span>
//                     </div>

//                     <div className={styles.notificationsfarmer}>
//                         {notifications.length > 0 ? (
//                             notifications.slice(0, 10).map((note, idx) => (
//                                 <div
//                                     key={idx}
//                                     className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""
//                                         }`}
//                                 >
//                                     <img
//                                         src={
//                                             note.createdBy?.profile
//                                                 ? `${BaseURL}/${note.createdBy.profile}`
//                                                 : dummyProfile
//                                         }
//                                         alt={note.createdBy?.firstName || "User"}
//                                     />
//                                     <div>
//                                         <p>{note.message}</p>
//                                         <span
//                                             className={note.isRead === false ? styles.redText : ""}
//                                         >
//                                             <FiClock
//                                                 className={note.isRead === false ? styles.redIcon : ""}
//                                             />{" "}
//                                             {new Date(note.createdAt || Date.now()).toLocaleDateString("en-GB")}
//                                         </span>
//                                     </div>
//                                 </div>
//                             ))
//                         ) : (
//                             <p className={styles.noNotifications}>No notifications available.</p>
//                         )}
//                     </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default EmployeeDashboard;

import React from 'react';
import styles from '../../assets/scss/Dashboard.module.scss';
import {
    FiBox,
    FiUsers,
    FiClock,
} from 'react-icons/fi';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from 'react-router-dom';
import dummyProfile from "../../assets/images/Profile.png";
import { useGetDashboardQuery } from '../../slices/admin/admin';
import { BaseURL } from '../../lib/api';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const EmployeeDashboard = () => {
    const navigate = useNavigate();
    const { data, isLoading, isError } = useGetDashboardQuery();

    // ✅ Handle loading and error states
    if (isLoading) {
        return <div className={styles.loader}>Loading dashboard...</div>;
    }

    if (isError) {
        return <div className={styles.error}>Failed to load dashboard data.</div>;
    }

    // ✅ Extract data safely
    const dashboard = data?.data || {};

    const {
        totalAssignedInvoices = 0,
        invoiceNeedAttention = 0,
        totalOrderAssigned = 0,
        orderNeedAttention = 0,
        notifications = [],
    } = dashboard;

    // ✅ Utility function to handle both S3 and local images
    const resolveImageUrl = (path) => {
        if (!path || typeof path !== "string") return dummyProfile;
        return path.startsWith("http") ? path : `${BaseURL}/${path}`;
    };

    return (
        <div className={styles.dashboard}>
            {/* ✅ Top Overview Section */}
            <div className={styles.grid}>
                {/* ✅ Invoice Overview */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Invoice Overview</h4>
                        <span onClick={() => navigate("/dashboard/Invoicetable")}>View all</span>
                    </div>
                    <div className={styles.overviewGridsEmployee}>
                        <div className={`${styles.box} ${styles.orange}`}>
                            <FiBox className={styles.icon} />
                            <h3>{totalAssignedInvoices}</h3>
                            <p>Total Assigned Invoices</p>
                        </div>
                        <div className={`${styles.box} ${styles.purple}`}>
                            <FiUsers className={styles.icon} />
                            <h3>{invoiceNeedAttention}</h3>
                            <p>Invoices Needing Attention</p>
                        </div>
                    </div>
                </div>

                {/* Order Overview */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Order Overview</h4>
                        <span onClick={() => navigate("/dashboard/Ordertable")}>View all</span>
                    </div>
                    <div className={styles.overviewGridsEmployee}>
                        <div className={`${styles.box} ${styles.green}`}>
                            <FiBox className={styles.icon} />
                            <h3>{totalOrderAssigned}</h3>
                            <p>Total Orders Assigned</p>
                        </div>
                        <div className={`${styles.box} ${styles.pink}`}>
                            <FiUsers className={styles.icon} />
                            <h3>{orderNeedAttention}</h3>
                            <p>Orders Needing Attention</p>
                        </div>
                    </div>
                </div>

                {/* Banner Slider */}
                <div className={styles.bannerCard}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Banner</h4>
                    </div>
                    <div className={styles.bannerSliderWrapper}>
                        {dashboard.bannerImages?.length > 0 ? (
                            <Slider
                                dots={true}
                                infinite={true}
                                speed={800}
                                slidesToShow={1}
                                slidesToScroll={1}
                                autoplay={true}
                                autoplaySpeed={3500}
                                arrows={false}
                            >
                                {dashboard.bannerImages.map((img, idx) => (
                                    <div key={idx} className={styles.bannerSlide}>
                                        <img
                                            src={typeof img === 'string' && img.startsWith('http') ? img : `${BaseURL}/${img.replace(/^\/+/, '')}`}
                                            alt={`banner-${idx}`}
                                            className={styles.bannerimg}
                                            onError={(e) => (e.target.src = dummyProfile)}
                                        />
                                    </div>
                                ))}
                            </Slider>
                        ) : (
                            <p>No banner images available</p>
                        )}
                    </div>
                </div>

                {/* ✅ Notifications Section */}
                <div className={styles.card}>
                    <div className={styles.header}>
                        <h4 className={styles.heading}>Notifications</h4>
                        <span onClick={() => navigate('/dashboard/Notifications')}>View all</span>
                    </div>

                    <div className={styles.notificationsfarmer}>
                        {notifications.length > 0 ? (
                            notifications.slice(0, 10).map((note, idx) => (
                                <div
                                    key={idx}
                                    className={`${styles.notification} ${note.isRead === false ? styles.unreadNotification : ""
                                        }`}
                                >
                                    <img
                                        src={resolveImageUrl(note.createdBy?.profile)}
                                        alt={note.createdBy?.firstName || "User"}
                                    />
                                    <div>
                                        <p>{note.message}</p>
                                        <span
                                            className={note.isRead === false ? styles.redText : ""}
                                        >
                                            <FiClock
                                                className={note.isRead === false ? styles.redIcon : ""}
                                            />{" "}
                                            {new Date(note.createdAt || Date.now()).toLocaleDateString("en-GB")}
                                        </span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className={styles.noNotifications}>No notifications available.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeDashboard;

